var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"app":"","padless":"","inset":""}},[_c('v-col',{attrs:{"cols":"12"}},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" — Powered by "),_c('strong',[_vm._v("Marcelo Rodovalho")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }